import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getDiasEspeciales,
  insertDiaEspecial,
  updateDiaEspecial,
  deleteDiaEspecial,
  getDiasEspecialesEditar,
  deleteDiaEspecialEditar,
  insertDiaEspecialEditar,
  getDiaEspecialById,
  updateDiaEspecialEditar,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_DIAS_ESPECIALES() {
  try {
    const diasEspecialesData = yield call(getDiasEspeciales)
    if (diasEspecialesData.ok) {
      yield put({
        type: actions.DIAS_ESPECIALES_LOAD_SUCCEEDED,
        payload: diasEspecialesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar días especiales')
      put({
        type: actions.DIAS_ESPECIALES_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DIAS_ESPECIALES_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_DIA_ESPECIAL(action) {
  try {
    const diaEspecialObj = yield call(insertDiaEspecial, action.payload)
    if (diaEspecialObj.ok) {
      putMessage(messageType.SUCCESS, 'Día Especial creado correctamente')
      yield put({
        type: actions.DIA_ESPECIAL_INSERT_SUCCEEDED,
        payload: diaEspecialObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear día especial')
      yield put({
        type: actions.DIA_ESPECIAL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear día especial')
    yield all([
      put({
        type: actions.DIA_ESPECIAL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_DIA_ESPECIAL_EDITAR(action) {
  try {
    const diaEspecialEditarObj = yield call(insertDiaEspecialEditar, action.payload)
    if (diaEspecialEditarObj.ok) {
      putMessage(messageType.SUCCESS, 'Día Especial creado correctamente')
      yield put({
        type: actions.DIA_ESPECIAL_EDITAR_INSERT_SUCCEEDED,
        payload: diaEspecialEditarObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear día especial')
      yield put({
        type: actions.DIA_ESPECIAL_EDITAR_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear día especial')
    yield all([
      put({
        type: actions.DIA_ESPECIAL_EDITAR_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_DIA_ESPECIAL(action) {
  try {
    const diaEspecialObj = yield call(updateDiaEspecial, action.payload)
    if (diaEspecialObj.ok) {
      putMessage(messageType.SUCCESS, 'Día Especial modificado correctamente')
      yield put({
        type: actions.DIA_ESPECIAL_UPDATE_SUCCEEDED,
        payload: diaEspecialObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar día especial')
      yield put({
        type: actions.DIA_ESPECIAL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar día especial')
    yield all([
      put({
        type: actions.DIA_ESPECIAL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_DIA_ESPECIAL(action) {
  try {
    const diaEspecialResult = yield call(deleteDiaEspecial, action.payload)
    if (diaEspecialResult.ok) {
      putMessage(messageType.SUCCESS, 'Día especial eliminado correctamente')
      yield put({
        type: actions.DIA_ESPECIAL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar día especial')
      yield put({
        type: actions.DIA_ESPECIAL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar día especial')
    yield all([
      put({
        type: actions.DIA_ESPECIAL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_DIAS_ESPECIALES_EDITAR(action) {
  try {
    const diasEspecialesEditarData = yield call(getDiasEspecialesEditar, action.payload)
    if (diasEspecialesEditarData.ok) {
      yield put({
        type: actions.DIAS_ESPECIALES_EDITAR_LOAD_SUCCEEDED,
        payload: diasEspecialesEditarData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar días especiales')
      put({
        type: actions.DIAS_ESPECIALES_EDITAR_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DIAS_ESPECIALES_EDITAR_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_DIA_ESPECIAL_EDITAR(action) {
  try {
    const diaEspecialEditarResult = yield call(deleteDiaEspecialEditar, action.payload)
    if (diaEspecialEditarResult.ok) {
      putMessage(messageType.SUCCESS, 'Día especial modificado correctamente')
      yield put({
        type: actions.DIA_ESPECIAL_EDITAR_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar día especial')
      yield put({
        type: actions.DIA_ESPECIAL_EDITAR_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar día especial')
    yield all([
      put({
        type: actions.DIA_ESPECIAL_EDITAR_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_DIA_ESPECIAL_BY_ID(action) {
  try {
    const diaEspecialData = yield call(getDiaEspecialById, action.payload)
    if (diaEspecialData.ok) {
      yield put({
        type: actions.DIA_ESPECIAL_BY_ID_LOAD_SUCCEEDED,
        payload: diaEspecialData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar día especial por Id')
      put({
        type: actions.DIA_ESPECIAL_BY_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.DIA_ESPECIAL_BY_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_DIA_ESPECIAL_EDITAR(action) {
  try {
    const diaEspecialEditarObj = yield call(updateDiaEspecialEditar, action.payload)
    if (diaEspecialEditarObj.ok) {
      putMessage(messageType.SUCCESS, 'Día Especial modificado correctamente')
      yield put({
        type: actions.DIA_ESPECIAL_EDITAR_UPDATE_SUCCEEDED,
        payload: diaEspecialEditarObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar día especial')
      yield put({
        type: actions.DIA_ESPECIAL_EDITAR_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar día especial')
    yield all([
      put({
        type: actions.DIA_ESPECIAL_EDITAR_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.DIAS_ESPECIALES_LOAD_REQUESTED, GET_DIAS_ESPECIALES),
    takeEvery(actions.DIA_ESPECIAL_INSERT_REQUESTED, INSERT_DIA_ESPECIAL),
    takeEvery(actions.DIA_ESPECIAL_UPDATE_REQUESTED, UPDATE_DIA_ESPECIAL),
    takeEvery(actions.DIA_ESPECIAL_DELETE_REQUESTED, DELETE_DIA_ESPECIAL),
    takeEvery(actions.DIAS_ESPECIALES_EDITAR_LOAD_REQUESTED, GET_DIAS_ESPECIALES_EDITAR),
    takeEvery(actions.DIA_ESPECIAL_EDITAR_DELETE_REQUESTED, DELETE_DIA_ESPECIAL_EDITAR),
    takeEvery(actions.DIA_ESPECIAL_EDITAR_INSERT_REQUESTED, INSERT_DIA_ESPECIAL_EDITAR),
    takeEvery(actions.DIA_ESPECIAL_BY_ID_LOAD_REQUESTED, GET_DIA_ESPECIAL_BY_ID),
    takeEvery(actions.DIA_ESPECIAL_EDITAR_UPDATE_REQUESTED, UPDATE_DIA_ESPECIAL_EDITAR),
  ])
}
